import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlanworkConfigService } from '@planwork/services/config.service';
import { DataStorage } from 'app/store/storage';
import formatRelativeWithOptions from 'date-fns/esm/fp/formatRelativeWithOptions/index.js';
import { ServiceService } from '../core/masterservice/service.service';
import { SidebarService } from '@planwork/services/sidebar.service';
declare var $: any;
import { filter } from 'rxjs/operators';
import { planworkConfig } from 'app/planwork.config';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  user: any;
  role_id: any;
  allNavigation: any;
  menu: any[] = [];
  SIDEBARDATA: any[] = [];
    apiUrl: any;
     dmsUrl: any;
  constructor(
    private loginService: ServiceService,
    private router: Router,
    private sidebarService: SidebarService,
    private planworkConfig: PlanworkConfigService,
  ) {
    this.user = JSON.parse(localStorage.getItem('userid'));
    this.role_id = JSON.parse(localStorage.getItem('roleId'));
    this.planworkConfig.sidebarHide.subscribe(res => {
      if (res == 1) {
        for (let list of this.menu) {
          list.isShow = false;
        }
      }
    });
        this.apiUrl = planworkConfig;
    if (this.apiUrl.baseUrl == 'https://sdmapidev.vertexplus.com/' || this.apiUrl.baseUrl == 'http://sdmapidev.vertexplus.com/') {

      this.dmsUrl = "https://dmsdev.vertexplus.com/dashboard";
    } else
    if (this.apiUrl.baseUrl == 'https://sdmapibeta.vertexplus.com/' || this.apiUrl.baseUrl == 'http://sdmapibeta.vertexplus.com/') {

      this.dmsUrl = "https://dmsbeta.vertexplus.com/dashboard";
    } else {

      this.dmsUrl = "https://dms.vertexplus.com/dashboard";
    }
  }

 ngOnInit(): void {
  // Always initialize and store full menu
  this.initializeSidebarMenu(); // calls setFullMenu internally

  const currentPage = localStorage.getItem('pageid');

// Step 1: Restore full menu from localStorage
  this.sidebarService.restoreMenuFromStorage();

  // Step 2: Try to filter by pageid


  if (currentPage) {
    this.sidebarService.updateMenuByGroup(currentPage);
  } else {
    this.sidebarService.updateMenuByGroup(null);
  }

  // Step 3: Subscribe to menu updates
  this.sidebarService.currentMenu.subscribe(menu => {
  const pageId = localStorage.getItem('pageid');
  if (pageId && menu && menu.length > 0) {
    this.menu = menu;
    console.log('this.menu: ', this.menu);
  } else {
    if (!this.menu || this.menu.length > 0) {
      this.menu = [];
      console.log('this.menu: ', "no menu found");
    }
  }
});

  // Mobile toggle logic
  $('.menum-btn').click(() => {
    $('#sidebar_left_main').addClass('active');
    $('.overlaym-all').addClass('active');
  });
  $('.overlaym-all').click(function () {
    $(this).removeClass('active');
    $('#sidebar_left_main').removeClass('active');
  });
}

  initializeSidebarMenu() {
    this.allNavigation = this.user?.UserRoleList;

    this.allNavigation?.forEach(element => {
      if (element.UserRoleId === this.role_id) {
        const menu = element.UserRolePermissionList;
        for (let list of menu) {
          list.activeClass = false;
          list.isShow = false;
        }

        // Do your RoleId and permission logic as before
        menu.forEach(menuEle => {
          menuEle.type = menuEle.RoleId?.includes(this.user.UserRole.UserRoleId);
          // Handle children role setup
          if (menuEle.children?.length > 0) {
            if(menuEle.children.findIndex(x=>x.id == "BranchPermission") > 0){
              menuEle.children?.splice(menuEle.children.findIndex(x=>x.id == "BranchPermission"), 1)
            }
            menuEle.children.forEach(child => {
              child.type = child.RoleId?.includes(this.user.UserRole.UserRoleId);
              child.children?.forEach(secmap => {
                secmap.type = secmap.RoleId?.includes(this.user.UserRole.UserRoleId);
                secmap.Buttons?.forEach(btn => {
                  btn.type = btn.RoleId?.includes(this.user.UserRole.UserRoleId);
                });
                secmap.children?.forEach(secchild => {
                  secchild.type = secchild.RoleId?.includes(this.user.UserRole.UserRoleId);
                  secchild.Buttons?.forEach(btn => {
                    btn.type = btn.RoleId?.includes(this.user.UserRole.UserRoleId);
                  });
                })
              });
            });
          }

          // // Handle Pages permission
          // menuEle.Pages?.forEach(page => {
          //   page.type = page.RoleId?.includes(this.user.UserRole.UserRoleId);
          // });
        });


        this.sidebarService.setFullMenu(menu);
      }
    });
  }
  itemTitle(item) {

    for (let list of this.menu) {
      list.activeClass = false;
      list.isShow = false;
    }
    if(item.id==='dms'){
      this.dms()
    }else{
     item.isShow = true;
    }
     item.activeClass = true;
  }
   dms() {
    // debugger
    // window.location.href = url + '?p='+ this.user.Token
    window.open(
      this.dmsUrl + '?p=' + this.user.Token,
      '_blank'
    );
  }
  chooseRoute(a, b) {
    localStorage.setItem('Mid', b.Mid);
    this.router.navigate([a.url]);
  }
  closeBar(item) {
    setTimeout(() => {
      item.isShow = false;
    }, 1);
  }
}
